import { render, staticRenderFns } from "./UserInquiryHistory.vue?vue&type=template&id=1116dd71&scoped=true"
import script from "./UserInquiryHistory.vue?vue&type=script&lang=js"
export * from "./UserInquiryHistory.vue?vue&type=script&lang=js"
import style0 from "./UserInquiryHistory.vue?vue&type=style&index=0&id=1116dd71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1116dd71",
  null
  
)

export default component.exports